import React, { useEffect, useState } from 'react';
import images from '../../Utils/images';
import { Route, Routes, useNavigate } from 'react-router-dom';
import colors from '../../Utils/colors';
import { eventsend } from '../../Config/analyticsFunctions';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { BsChat, BsGlobe, BsKey, BsPeople } from 'react-icons/bs';
import { LuBookMinus } from 'react-icons/lu';
import { IoWalletOutline } from 'react-icons/io5';
import { PiWebhooksLogoLight } from 'react-icons/pi';
import './styles.scss';
import People from '../ManageProfile/Components/People';
import { APIKey } from '../ManageProfile/Components/APIKey';
import PlanDetails from '../ManageProfile/Components/PlanDetails';
import PaymentDetails from '../Templates/Components/PaymentDetails';
import SubscriptionDetails from '../Templates/Components/SubscriptionDetails';
import ChatPreferences from '../ManageProfile/Components/ChatPreferences';
import { AppSumoDetails } from '../ManageProfile/Components/AppSumoDetails';
import Webhooks from '../ManageProfile/Components/Webhooks';
import Attributes from '../ManageProfile/Components/Attributes';
import DomainDetails from '../ManageProfile/Components/DomainDetails';

const AccountSettings = () => {
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState('People');
  const localdata = useSelector((state) => state.main.localdata);
  const agentdata = useSelector((state) => state.main.agentdata);
  const isPremiumUser = localdata?.premium;
  const isEnterpriseUser = localdata?.premiumPlanName === 'Enterprise';

  useEffect(() => {
    navigate('/settings/people');
    const url = window.location.pathname;
    if (url == '/settings/apikey' && agentdata) {
      toast.error('Feature access denied. You do not have permission to access this feature', {
        autoClose: true,
        position: 'top-right',
      });
      navigate('/creator');
    }
  }, []);

  const SidemenuItem = ({ icon, title }) => {
    return (
      <>
        <div
          className="sidemenu-item"
          onClick={() => {
            setSelectedItem(title);
            switch (title) {
              //   case 'Account details':
              //     navigate('/settings');
              //     break;
              case 'People':
                navigate('/settings/people');
                break;
              case 'API Key':
                navigate('/settings/apikey');
                break;
              case 'Domain Details':
                navigate('/settings/domainDetails');
                break;
              case 'Your AppSumo Plan':
                navigate('/settings/planDetails');
                break;
              case 'Subscriptions':
                navigate('/settings/subscriptions');
                break;
              case 'Payments':
                navigate('/settings/paymentDetails');
                break;
              case 'Inbox Settings':
                navigate('/settings/preferences');
                break;
              case 'All AppSumo Plans':
                navigate('/settings/appSumo');
                break;
              case 'Webhooks':
                navigate('/settings/webhooks');
                break;
              case 'Attributes':
                eventsend('Attributes-tab_Navigation-bar_clicked');
                navigate('/settings/attributes');
            }
          }}
        >
          <div
            className="sidemenu-item__container"
            style={{
              backgroundColor: selectedItem === title ? colors.lightPurple : '',
            }}
          >
            {icon}
            <p
              className=""
              style={{
                color: selectedItem === title ? colors.primary04 : colors.black,
              }}
            >
              {title}
            </p>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="settings">
        <div className="settings__header">
          <img
            src={images.BackArrowBlack}
            className="image-20"
            onClick={() => {
              navigate('/creator');
            }}
          />
          <h3>{'Account Settings'}</h3>
        </div>
        <div className="settings__body">
          <div className="settings__body__sidemenu">
            {isPremiumUser && <SidemenuItem icon={<BsPeople size={18} color={selectedItem === 'People' ? '#5A3897' : '#262626'} />} title={'People'} />}
            {isPremiumUser && !agentdata && localdata?.premiumPlanName !== 'Free_OB_6Mths' && (
              <SidemenuItem icon={<BsKey size={18} color={selectedItem === 'API Key' ? '#5A3897' : '#262626'} />} title={'API Key'} />
            )}
            {/* {isEnterpriseUser && isPremiumUser && !agentdata && (
              <SidemenuItem
                icon={
                  <BsGlobe size={18} color={selectedItem === 'Domain Details' ? '#5A3897' : '#262626'} />
                }
                title={'Domain Details'}
              />
            )} */}
            {/* {isPremiumUser && localdata?.isAppsumoUser && (
              <SidemenuItem
                icon={
                  <LuBookMinus
                    size={18}
                    color={selectedItem === 'Plan Details' ? '#5A3897' : '#262626'}
                  />
                }
                title={'Your AppSumo Plan'}
              />
            )} */}
            {/* {isPremiumUser && (
              <SidemenuItem
                icon={
                  <IoWalletOutline
                    size={18}
                    color={selectedItem === 'Payments' ? '#5A3897' : '#262626'}
                  />
                }
                title={'Payments'}
              />
            )} */}
            {/* {isPremiumUser && (
              <SidemenuItem
                icon={
                  <IoWalletOutline
                    size={18}
                    color={selectedItem === 'Subscriptions' ? '#5A3897' : '#262626'}
                  />
                }
                title={'Subscriptions'}
              />
            )} */}
            {/* {isPremiumUser && (
              <SidemenuItem
                icon={
                  <BsChat
                    size={18}
                    color={selectedItem === 'Inbox Settings' ? '#5A3897' : '#262626'}
                  />
                }
                title={'Inbox Settings'}
              />
            )} */}
            {/* {isPremiumUser && localdata?.isAppsumoUser && (
              <SidemenuItem
                icon={
                  <BsPeople
                    size={18}
                    color={selectedItem === 'AppSumo Details' ? '#5A3897' : '#262626'}
                  />
                }
                title={'All AppSumo Plans'}
              />
            )} */}
            {/* {isPremiumUser && (
              <SidemenuItem
                icon={
                  <PiWebhooksLogoLight
                    size={18}
                    color={selectedItem === 'Webhooks' ? '#5A3897' : '#262626'}
                  />
                }
                title={'Webhooks'}
              />
            )} */}
            {isPremiumUser && (
              <SidemenuItem
                icon={
                  <i
                    className={`pi pi-at`}
                    style={{
                      fontSize: 18,
                      color: selectedItem === 'Attributes' ? '#5A3897' : '#262626',
                    }}
                  ></i>
                }
                title={'Attributes'}
              />
            )}
          </div>
          <div className="settings__body__content">
            <Routes>
              <Route path="people" element={<People />} />
              <Route path="apikey" element={<APIKey />} />
              <Route path="planDetails" element={<PlanDetails />} />
              <Route path="paymentDetails" element={<PaymentDetails />} />
              <Route path="subscriptions" element={<SubscriptionDetails />} />
              <Route path="preferences" element={<ChatPreferences />} />
              <Route path="appSumo" element={<AppSumoDetails />} />
              <Route path="webhooks" element={<Webhooks />} />
              <Route path="attributes" element={<Attributes />} />
              <Route path="domainDetails" element={<DomainDetails />} />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountSettings;
